export const LoadingSkeleton0 = () => {
  return (
    <div className="flex w-full animate-pulse">
      <div className="w-20 h-6 bg-gray-200 mr-4 rounded"></div>
      <div className="w-20 h-6 bg-gray-200 mr-4 rounded"></div>
      <div className="w-20 h-6 bg-gray-200 mr-4 rounded"></div>
      <div className="w-20 h-6 bg-gray-200 mr-4 rounded"></div>
    </div>
  );
};

export const LoadingSkeleton1 = () => {
  return (
    <div className="w-full md:w-2/3 md:mr-5 animate-pulse">
      <div className="pt-20">
        <div className="w-20 h-6 bg-gray-200 mr-4 rounded"></div>
      </div>
      <div className="pt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
      </div>
      <div className="pt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
        <div className="h-32 bg-gray-200 mr-4 rounded"></div>
      </div>
    </div>
  );
};

export const LoadingSkeleton2 = () => {
  return (
    <div className="border-t w-full flex flex-col justify-center items-center cursor-pointer mx-auto font-semibold text-shade-dark text-sm">
      <div role="status" className="w-full p-2 py-6 border-y animate-pulse duration-500">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2">
            <div className="h-3 bg-gray-300 rounded-full w-24 mb-2.5"></div>
            <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
          </div>
        </div>

        <span className="sr-only">Loading...</span>
      </div>
      <div role="status" className="w-full p-2 py-6 border-y animate-pulse duration-500">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2">
            <div className="h-3 bg-gray-300 rounded-full w-24 mb-2.5"></div>
            <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
          </div>
        </div>
        <span className="sr-only">Loading...</span>
      </div>
      <div role="status" className="w-full p-2 py-6 border-y animate-pulse duration-500">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2">
            <div className="h-3 bg-gray-300 rounded-full w-24 mb-2.5"></div>
            <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
            <div className="h-2 bg-gray-300 rounded-full w-12"></div>
          </div>
        </div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export const LoadingSkeleton3 = () => {
  return (
    <>
      <div className="bg-white p-2 rounded-lg">
        <div className="flex flex-col p-2 pt-4 w-full animate-pulse">
          <div className="pb-6 grid grid-cols-1 gap-4">
            <div className="h-12 bg-gray-200 rounded"></div>
          </div>
          <div className="flex gap-4 w-full animate-pulse">
            <div className="w-1/4 h-6 bg-gray-200 rounded"></div>
            <div className="w-1/4 h-6 bg-gray-200 rounded"></div>
            <div className="w-1/4 h-6 bg-gray-200 rounded"></div>
            <div className="w-1/4 h-6 bg-gray-200 rounded"></div>
          </div>
          <div className="pt-6 grid grid-cols-1 gap-4">
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-white p-2 rounded-lg">
        <div className="flex flex-col p-2 pt-4 w-full animate-pulse">
          <div className="flex gap-4 w-full animate-pulse">
            <div className="w-1/2 h-6 bg-gray-200 rounded"></div>
            <div className="w-1/2 h-6 bg-gray-200 rounded"></div>
          </div>
          <div className="pt-6 grid grid-cols-1 gap-4">
            <div className="h-16 bg-gray-200 rounded"></div>
            <div className="h-16 bg-gray-200 rounded"></div>
            <div className="h-16 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export const LoadingSkeleton4 = () => {
  return (
    <div className="bg-white p-2 rounded-lg">
      <div className="flex flex-col p-2 w-full animate-pulse">
        <div className="mb-8 h-10 w-1/2 bg-gray-200 rounded"></div>
        <div className="grid grid-cols-2 gap-4">
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
          <div className="h-12 col-span-2 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export const LoadingSkeleton5 = () => {
  return (
    <div className="margin-x py-10 ">
      <div className="min-h-[22rem] flex max-md:flex-col-reverse gap-10 bg-white p-4 rounded-lg">
        <div className="flex md:w-1/2 flex-col gap-4 animate-pulse">
          <div className="mb-8 h-10 w-1/2 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <br />
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
        <div className="h-72 md:w-1/2 bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export const LoadingSkeleton6 = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 p-10 items-center">
      <div className="h-40 bg-gray-200 rounded" />
      <div className="h-40 bg-gray-200 rounded" />
      <div className="h-40 bg-gray-200 rounded" />
      <div className="h-40 bg-gray-200 rounded" />
      <div className="h-40 bg-gray-200 rounded" />
      <div className="h-40 bg-gray-200 rounded" />
    </div>
  );
};
